export default {
  currentMedKeyTypeName(state) {
    return state.currentMedKeyTypeName;
  }
};
